export default "__VITE_ASSET__CwOsRSQb__"